export function OutcomeRow({ icon, name, percent, price }: { icon: React.ReactNode; name: string; percent: number; price: string }) {
	return (
		<div className='flex w-full items-center gap-2'>
			<div className='flex flex-1 items-center gap-2 overflow-hidden'>
				{icon}
				<div className='line-clamp-1 flex-1 text-sm font-normal leading-[132%] tracking-[-0.21px] text-foreground'>{name}</div>
			</div>
			<div className='flex items-center gap-2 py-[7px]'>
				<div className='line-clamp-1 text-right text-sm font-medium leading-[132%] tracking-[-0.21px] text-success'>{percent.toFixed(2)}%</div>
				<div className='line-clamp-1 w-12 text-right text-sm font-medium leading-[132%] tracking-[-0.21px] text-foreground'>${price}</div>
			</div>
		</div>
	)
}
